import React from "react";
import "../../admin/AdminOrders/admin-orders.css";
import {TableDateSearchProvider} from "../../admin/Context/TableDateSearchContext.jsx";
import {CompanyOrders} from "./CompanyOrders.jsx";

export const CompanyOrdersWrapper = ({match, withHeader = true}) => {
    return (
        <>
            <TableDateSearchProvider>
                <CompanyOrders match={match} withHeader={withHeader} />
            </TableDateSearchProvider>
        </>
    );
};
